import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './sections.generated.css';
import './site.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
